// axios.js (configure once)
import axios from 'axios';
// console.log("API URL:", process.env.REACT_APP_API_URL);
// console.log("API KEY:", process.env.REACT_APP_CHATBOT_API_KEY);


// axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// axios.defaults.headers.common['X-Api-Key'] = process.env.REACT_APP_CHATBOT_API_KEY;

// export default axios;


// This is a SEPARATE instance only for chatbot
const chatbotAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'X-Api-Key': process.env.REACT_APP_CHATBOT_API_KEY
    }
});

export default chatbotAxios;